export default __webpack_public_path__ + "static/Iphone mockup apace-18e6d660c7f7a0dd9a311182b69baa64.png";